import classNames from "classnames";
import { ReactNode } from "react";

export function Info({
  info,
  displayInfo = true,
}: {
  info?: string | ReactNode;
  displayInfo?: boolean;
}) {
  return (
    <div
      className={classNames("text-sm bg-gray-100 p-2 my-2 rounded", {
        hidden: !info || !displayInfo,
      })}
    >
      {info}
    </div>
  );
}
